<!--
 * @Description: 会议管理
 * @Author: PF
 * @Date: 2024-09-11 14:21:54
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:22:47
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">会议管理</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openList', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="会议编号" label-align="right" align="left" width="120px" span="2">{{ruleForm.hybh}}</el-descriptions-item>
        <el-descriptions-item label="会议名称" label-align="right" align="left" width="120px" span="2">{{ruleForm.hymc}}</el-descriptions-item>
        <el-descriptions-item label="会议主要内容" label-align="right" align="left" width="120px" span="2">{{ruleForm.hyzynr}}</el-descriptions-item>
        <el-descriptions-item label="会议主持人" label-align="right" align="left" width="120px" span="2">{{ruleForm.hyzcrxm}}</el-descriptions-item>
        <el-descriptions-item label="会议开始时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.hykssj}}</el-descriptions-item>
        <el-descriptions-item label="会议结束时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.hyjssj}}</el-descriptions-item>
        <el-descriptions-item label="会议地点" label-align="right" align="left" width="120px" span="4">{{ruleForm.hydd}}</el-descriptions-item>
        <el-descriptions-item label="参会人员" label-align="right" align="left" width="120px" span="4">{{ruleForm.jzgmcs}}</el-descriptions-item>
        <el-descriptions-item label="会议纪要" label-align="right" align="left" width="120px" span="4">{{ruleForm.hyjy}}</el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openList', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openList: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openList', 'ReturnData'])

const ruleForm = ref({})

const row = ref()
watch(
  () => props.openList,
  () => {
    if (props.openList) {
      row.value = props.row
      loadData({
        url: '/api/v2/bangong/bangonghuiyiguanli/shouye/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
</style>
